import { useCallback, useEffect, useState } from 'react';
import { User } from 'oidc-client-ts';
import { checkUserEmailConfirmed } from 'src/common/email-verification';

type UseEmailVerifiedOpts = {
  user: User | null | undefined;
  auto?: boolean;
};

export function useEmailVerified({ user, auto = true }: UseEmailVerifiedOpts) {
  const [checking, setChecking] = useState(false);
  const [verified, setVerified] = useState<boolean>(false);

  const check = useCallback(async (): Promise<boolean> => {
    setChecking(true);
    try {
      const ok = await checkUserEmailConfirmed(user);
      setVerified(ok);
      return ok;
    } finally {
      setChecking(false);
    }
  }, [user]);

  useEffect(() => {
    if (!auto || !user) return;
    void check();
  }, [auto, user, check]);

  return { verified, checking, check, setChecking };
}
